/* BLISART · HALLOWEEN 2026 - pantalla de entrada */
(function () {
  "use strict";
  var el = null, cerrado = false, timer = null;

  function salir() {
    if (!el || cerrado) return;
    cerrado = true;
    if (timer) { clearTimeout(timer); timer = null; }
    pararParticulas();
    el.classList.add("is-out");
    document.documentElement.classList.remove("nb-hw-lock");
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 1000);
  }



  /* ---------------------------------------------------------------
     PARTICULAS: chispas calidas que orbitan "BlisArt Paper".
     Canvas propio, sin librerias, se apaga al salir de la intro.
     --------------------------------------------------------------- */
  var RAF = [], sparkles = null;

  function pararParticulas() {
    RAF.forEach(function (id) { cancelAnimationFrame(id); });
    RAF = [];
    sparkles = null;
  }

  function lanzarParticulas() {
    var cv = document.getElementById("nbHwSparkles");
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext("2d");
    if (!ctx) return;

    var marca = document.querySelector(".nb-hw__brand em") || document.querySelector(".nb-hw__brand");
    var dpr = Math.min(1.5, window.devicePixelRatio || 1);
    var w = 0, h = 0;

    function medir() {
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = Math.round(w * dpr);
      cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    /* las particulas giran ALREDEDOR DE LA PALABRA "Paper" */
    var zonaEl = marca;
    function zona() {
      var el = zonaEl || marca;
      var c = cv.getBoundingClientRect();
      if (!el) return { x: w/2, y: h/2, rx: Math.min(w*0.3, 240), ry: 110 };
      var r = el.getBoundingClientRect();
      return {
        x: r.left - c.left + r.width/2,
        y: r.top - c.top + r.height/2,
        rx: r.width/2 + 54,     // un poco mas ancho que la palabra
        ry: r.height/2 + 44     // y un poco mas alto, para que la envuelvan
      };
    }

    var ps = [];
    function crear() {
      var z = zona();
      var ang = Math.random() * Math.PI * 2;
      var rad = 0.62 + Math.random() * 0.55;          // arrancan alrededor del texto
      return {
        ang: ang,
        rad: rad,
        vel: (Math.random() < .5 ? -1 : 1) * (0.0042 + Math.random() * 0.0064),
        radio: rad,
        sube: 0.10 + Math.random() * 0.30,
        tam: 0.9 + Math.random() * 2.4,
        a: 0.28 + Math.random() * 0.55,
        parp: 0.4 + Math.random() * 1.6,
        fase: Math.random() * Math.PI * 2,
        t: 0,
        dorada: Math.random() < 0.55
      };
    }

    medir();
    var n = w < 640 ? 24 : 48;
    for (var i = 0; i < n; i++) ps.push(crear());

    var t0 = performance.now(), frame = 0, z = zona(), ultimoDibujo = 0;
    function paso(now) {
      if (!sparkles) return;
      // 30 fotogramas por segundo bastan para chispas lentas: la mitad de trabajo
      if (now - ultimoDibujo < 33) { RAF.push(requestAnimationFrame(paso)); return; }
      ultimoDibujo = now;
      // si la intro ya no se ve, no se dibuja nada
      if (document.hidden) { RAF.push(requestAnimationFrame(paso)); return; }
      ctx.clearRect(0, 0, w, h);
      var vida = (now - t0) / 1000;
      // la zona del texto se recalcula 1 de cada 12 frames: es lo caro
      if (((frame = (frame + 1) % 12)) === 0) z = zona();
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        p.t += 0.016;
        // orbita suave + deriva hacia arriba + parpadeo
        p.ang += p.vel;
        p.rad = p.radio + Math.sin(p.t * p.parp + p.fase) * 0.16;
        var px = z.x + Math.cos(p.ang) * z.rx * p.rad;
        var py = z.y + Math.sin(p.ang) * z.ry * p.rad - (vida * p.sube * 16) % 90;
        var alfa = p.a * (0.55 + 0.45 * Math.sin(p.t * p.parp + p.fase));
        if (alfa < 0) alfa = 0;
        ctx.fillStyle = "rgba(" + (p.dorada ? "255,214,150" : "240,178,126") + "," + (alfa * 0.42).toFixed(3) + ")";
        ctx.beginPath();
        ctx.arc(px, py, p.tam * 2.3, 0, 6.2832);
        ctx.fill();
        ctx.fillStyle = "rgba(255,244,224," + (alfa * 0.92).toFixed(3) + ")";
        ctx.beginPath();
        ctx.arc(px, py, p.tam * 0.75, 0, 6.2832);
        ctx.fill();
      }
      RAF.push(requestAnimationFrame(paso));
    }
    sparkles = cv;
    RAF.push(requestAnimationFrame(paso));
    window.addEventListener("resize", medir);
  }

  function iniciar() {
    el = document.getElementById("nbHw");
    if (!el) return;


    // cuanto dura la mini carga (segundos configurables)
    var seg = parseFloat(el.getAttribute("data-duracion") || "3.4");
    el.style.setProperty("--hw-ms", Math.max(1200, seg * 1000) + "ms");
    timer = setTimeout(salir, Math.max(1200, seg * 1000));

    /* particulas alrededor de la marca */
    lanzarParticulas();

    // la intro se cierra sola a los 4s, o al pulsar en cualquier sitio
    el.addEventListener("click", function () { salir(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.key === "Enter") salir();
    });

    // el video puede tardar: no bloquea, es decorativo
    var v = el.querySelector("video");
    if (v) { v.play && v.play().catch(function () {}); }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else { iniciar(); }
})();
